import React from 'react';
import Button from 'screens/components/basic/Button';
import BranchSelectAutoCompleteInput from 'screens/components/basic/BranchSelectAutoCompleteInput';
import LOOKUP from 'constants/lookup';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import VisibilityIcon from '@mui/icons-material/Visibility';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

const componentName = "MonthlyProfitReport";

const Header = (props) => (
    <div className="searchBarContainer">
        <div className="row m-0">
            <div className="col-xs-6 col-sm-6 col-md-2 col-lg-2 col-xl-2 m-0">
                <DatePickerInput
                    name={componentName + LOOKUP.report.common.beginDate.name}
                    floatingLabelText={LOOKUP.report.common.beginDate.label}
                    hintText={LOOKUP.report.common.beginDate.label}
                    fullWidth={true}
                />
            </div> {/* .col */}
            <div className="col-xs-6 col-sm-6 col-md-2 col-lg-2 col-xl-2">
                <DatePickerInput
                    name={componentName + LOOKUP.report.common.endDate.name}
                    floatingLabelText={LOOKUP.report.common.endDate.label}
                    hintText={LOOKUP.report.common.endDate.label}
                    fullWidth={true}
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                <BranchSelectAutoCompleteInput
                    name={componentName + LOOKUP.report.common.branchName}
                    label={LOOKUP.report.common.branch + "*"}
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 mt-1 mb_xs p-0">
                <Button
                    type="IconInButton"
                    className="pull-right mt-2 ml-1"
                    name={componentName + LOOKUP.report.common.viewReport.name}
                    label={LOOKUP.report.common.viewReport.label}
                    icon={<VisibilityIcon />}
                    onTouchTap={props.showBody}
                />
                <Button
                    type="DownloadButton"
                    className="pull-right mt-2"
                    name={componentName + LOOKUP.report.common.downloadReport.name}
                    label={LOOKUP.report.common.downloadReport.label}
                    onTouchTap={props.download}
                />
            </div>
            {/* <Button
                className="pull-right mt-2 ml-1"
                mini={true}
                name={componentName + LOOKUP.report.common.exportExcel.name}
                label={LOOKUP.report.common.exportExcel.label}
            />
            <Button
                className="pull-right mt-2"
                mini={true}
                name={componentName + LOOKUP.report.common.print.name}
                label={LOOKUP.report.common.print.label}
            /> */}
        </div>
    </div>
);

export default Header;
